import React, { useState, useEffect, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { AlertContext } from "../../Dashboard/Dashboard";
import { CustomerService } from "../../../services/CustomerService";
import StyledTextField from "../StyledTextField/StyledTextField";

export default function CustomerAutocomplete({
  label,
  title,
  width,
  defaultInput,
  selectedOption,
  updateSelectedCustomer,
  disabled,
  error
}) {
  const { instance } = useMsal();
  const [options, setOptions] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const { warning } = useContext(AlertContext);

  useEffect(() => {
    if (searchInput.length > 3) {
      setTimeout(() => {
        CustomerService.GetCustomersByNameOrId(instance, searchInput).then(res => {
          setOptions(res.map(({ name }) => name));
        }).catch(error => {
          console.error(error);
          warning(error);
        });
      }, 1);
    } else {
      setOptions([]);
    }
  }, [searchInput]);

  useEffect(() => {
    if (defaultInput) {
      setSearchInput(defaultInput);
    }
  }, [defaultInput]);

  return useMemo(() => {
    return (
      <Autocomplete
        id={`autocomplete-${label}`}
        freeSolo
        autoHighlight
        filterSelectedOptions
        multiple
        disabled={disabled}
        value={selectedOption}
        onChange={(event, newValue) => updateSelectedCustomer(newValue)}
        options={options}
        filterOptions={(x) => x}
        sx={{
          width: width,
          "& .MuiOutlinedInput-root": {
            padding: "1.5px 39px 1.5px 0 !important",
          }
        }}
        inputValue={searchInput}
        PaperComponent={
          ({ children }) =>
            <Paper sx={{
              backgroundColor: "black_solid.10",
              fontSize: "body1.fontSize",
              fontWeight: "body1.fontWeight",
              boxShadow: "elevation1"
            }}
            >
              {children}
            </Paper>
        }
        onInputChange={(event, newInputValue) => {
          setSearchInput(newInputValue);
        }}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={option =>
          option && `${option}`
        }
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip key={`chip-${option}`} size="small" label={option} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) =>
          <StyledTextField
            {...params}
            label={label || title}
            error={error}
            size="small"
          />
        }
      />
    );
  }, [options, searchInput, selectedOption, disabled, error]);
}

CustomerAutocomplete.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  defaultInput: PropTypes.string,
  selectedOption: PropTypes.any,
  updateSelectedCustomer: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool
};